import { DISPLAY_TYPE_CATEGORY_ENUM } from "./enum";
import aboutUs1 from "../imgs/displayType/about_us_1.png";
import statistical2 from "../imgs/displayType/statistical_2.png";
import businessAreas3 from "../imgs/displayType/business_areas_3.png";
import featuredNews4 from "../imgs/displayType/featured_news_4.png";
import partnerAndCertificate5 from "../imgs/displayType/partner_and_certificate_5.png";
import introduce6 from "../imgs/displayType/introduce_6.png";
import missionAndVision8 from "../imgs/displayType/mission_and_vision_8.png";
import leadership9 from "../imgs/displayType/leadership_9.png";
import news10 from "../imgs/displayType/news_10.png";
import news11 from "../imgs/displayType/news_11.png";
import human12 from "../imgs/displayType/human_12.png";
import product20 from "../imgs/displayType/product_20.png";
import categoryProduct21 from "../imgs/displayType/category_product_21.png";

export const DisplayTypeCategory = [
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.ABOUT_US}. Về chúng tôi`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.ABOUT_US,
      src: aboutUs1
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.STATISTICAL}. Thống kê`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.STATISTICAL,
      src: statistical2
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.BUSINESS_AREAS}. Lĩnh vực kinh doanh`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.BUSINESS_AREAS,
      src: businessAreas3
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.FEATURED_NEWS}. Tin tức nổi bật`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.FEATURED_NEWS,
      src: featuredNews4
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.PARTNER_AND_CERTIFICATE}. Đối tác và chứng chỉ`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.PARTNER_AND_CERTIFICATE,
      src: partnerAndCertificate5
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.INTRODUCE}. Giới thiệu`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.INTRODUCE,
      src: introduce6
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.MISSION_AND_VISION}. Sứ mệnh và tầm nhìn`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.MISSION_AND_VISION,
      src: missionAndVision8
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.LEADERSHIP}. Ban lãnh đạo`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.LEADERSHIP,
      src: leadership9
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.NEWS}. Tin tức`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.NEWS,
      src: news10
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.NEWS11}. Tin tức 2`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.NEWS11,
      src: news11
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.HUMAN}. Con người`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.HUMAN,
      src: human12
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.PRODUCT}. Sản phẩm`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.PRODUCT,
      src: product20
    },
    {
      label: `${DISPLAY_TYPE_CATEGORY_ENUM.CATEGORY_PRODUCT}. Danh mục sản phẩm`,
      value: DISPLAY_TYPE_CATEGORY_ENUM.CATEGORY_PRODUCT,
      src: categoryProduct21
    },
  ];